import { ref, computed } from 'vue'
import FieldService from '@/services/FieldService'
import { host } from '@/services/HostAPI'
import { officeAlertService } from '@/services/OfficeAlertService'
import { selectListCache } from '@/services/SelectListCache'
import { geoLocationLogService } from '@/services/GeoLocationLogService'

const loggedOutState = {
  UserData: {
    UserName: 'Unknown',
    OfficeId: null,
    OfficeCode: null,
    OfficeName: null,
    UserId: null,
    LoginName: null
  },
  TenantId: null,
  ApiKey: '',
  MustChangePassword: false,
  IsSysAdmin: false
}

const structuredClone = obj => {
  return JSON.parse(JSON.stringify(obj))
}

const sessionState = ref(structuredClone(loggedOutState))

const login = async (tenantId, rq) => {
  sessionState.value.TenantId = tenantId
  FieldService.setTenantId(tenantId)
  const rs = await host.session.login(rq)
  if (rs.IsSuccess) {
    sessionState.value.UserData.UserName = rs.UserData.UserName
    sessionState.value.UserData.OfficeId = rs.UserData.OfficeId
    sessionState.value.UserData.OfficeCode = rs.UserData.OfficeCode
    sessionState.value.UserData.OfficeName = rs.UserData.OfficeName
    sessionState.value.UserData.UserId = rs.UserData.UserId
    sessionState.value.UserData.LoginName = rs.UserData.LoginName
    sessionState.value.ApiKey = rs.ApiKey
    sessionState.value.MustChangePassword = rs.MustChangePassword
    sessionState.value.IsSysAdmin = rs.IsSysAdmin
    saveToLocalStorage(sessionState.value)
    FieldService.setAuthToken(rs.ApiKey)
    officeAlertService.subscribe()
    selectListCache.reset()
    geoLocationLogService.start()
  }

  return { IsSuccess: rs.IsSuccess, Message: rs.Message }
}

const logout = () => {
  geoLocationLogService.stop()
  sessionState.value = structuredClone(loggedOutState)
  console.log({
    loc: 'UserSession/logout',
    loggedOutState: loggedOutState,
    sessionState: sessionState.value
  })
  FieldService.setTenantId(null)
  saveToLocalStorage(null)
}

const isUserIdPopulated = () => {
  return sessionState.value.UserData.UserId ? true : false
}

const isLoggedIn = () => {
  console.log({
    loc: 'UserSession/isLoggedIn',
    userIdPopulated: isUserIdPopulated()
  })
  if (!isUserIdPopulated()) {
    retrieveFromLocalStorage()
    if (isUserIdPopulated()) {
      geoLocationLogService.start()
    }
  }

  return isUserIdPopulated()
}

const saveToLocalStorage = info => {
  const userString = JSON.stringify(info)
  console.log({
    loc: 'UserSession/saveToLocalStorage',
    info: info,
    userString: userString
  })
  localStorage.setItem('user', userString)
}

const retrieveFromLocalStorage = () => {
  const userString = localStorage.getItem('user')
  console.log({
    loc: 'UserSession/retrieveFromLocalStorage',
    userString: userString
  })
  if (userString && userString.startsWith('{')) {
    const newSessionState = JSON.parse(userString)
    console.log({
      loc: 'UserSession/retrieveFromLocalStorage',
      newSessionState: newSessionState
    })
    if (newSessionState.TenantId) {
      sessionState.value = newSessionState
      FieldService.setAuthToken(sessionState.value.ApiKey)
      FieldService.setTenantId(sessionState.value.TenantId)
    }
  }
}

const resetMustChangePassword = () => {
  sessionState.value.MustChangePassword = false
  saveToLocalStorage(sessionState.value)
}

const userData = computed(() => {
  return sessionState.value.UserData
})

const apiKey = computed(() => {
  return sessionState.value.ApiKey
})

const mustChangePassword = computed(() => {
  return sessionState.value.MustChangePassword
})

const isSysAdmin = computed(() => {
  return sessionState.value.IsSysAdmin
})

export {
  userData,
  apiKey,
  mustChangePassword,
  login,
  logout,
  isLoggedIn,
  resetMustChangePassword,
  isSysAdmin
}
